<template>
  	<div class="locale-changer">

    	<!-- <span>current language = {{$i18n.locale}}</span><br/> -->

		<f-button @click="changeLanguage" :type="'image'">
			<img v-if='$i18n.locale == "en"' src="@/assets/img/flag_nl.png"/>
			<img v-else src="@/assets/img/flag_uk.png"/>
		</f-button>

  	</div>
</template>


<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
export default {
  	name: 'LocaleChanger',
  	components: {
  	},
	methods: {
		changeLanguage: function() {
			this.$i18n.locale == "en" ? this.$i18n.locale = "nl" : this.$i18n.locale = "en"
		}
	}
}
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss">

</style>
